export const GREEN_STATUSES = ['APPROVED', 'SENT', 'PAID'];
export const YELLOW_STATUSES = ['WORKLOGS_READY', 'INVOICE_READY'];
export const RED_STATUSES = ['DECLINED', 'CLIENT_REJECTED'];
export const GRAY_STATUSES = ['ON_ALLOCATIONS', 'ON_WORKLOGS'];
